import { jsx as _jsx } from "react/jsx-runtime";
export function Kbd({ children }) {
    return _jsx("kbd", { style: { border: '1px solid var(--border-strong)', borderRadius: 3, padding: '0 5px', fontSize: 11, fontFamily: 'inherit', background: 'var(--surface)', lineHeight: 1.6 }, children: children });
}
export function KeyBadge({ children }) {
    return _jsx("span", { style: { width: 22, height: 22, borderRadius: 3, border: '1px solid var(--border-strong)', display: 'inline-grid', placeItems: 'center', fontSize: 11.5, fontWeight: 600, color: 'var(--text-2)', flex: 'none', background: 'var(--surface)' }, children: children });
}
//# sourceMappingURL=Kbd.js.map